var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-block",on:{"click":_vm.signInWithGithub}},[_vm._t("default"),_c('i',{staticClass:"fa ml-10 fa-github-alt"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }